import { Tag, Copy } from "lucide-react";
import { useState } from "react";

// <-- Sobrescribimos el tipo aquí para garantizar compatibilidad con la nueva data
export interface CouponCardProps {
	code: string;
	discount: number;
	validUntil?: string;
	type: string;
	status: string;
}

export const CouponCard = ({
	code,
	discount,
	validUntil,
	type,
	status,
}: CouponCardProps) => {
	const [copied, setCopied] = useState(false);

	const handleCopy = () => {
		if (!code) return;
		navigator.clipboard.writeText(code);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	return (
		<div className='shrink-0 w-full h-full flex flex-col border border-gray-200 shadow-sm p-5 rounded-2xl'>
			{/* --- Header --- */}
			<div className='flex items-center justify-between mb-4'>
				<div className='flex gap-2 items-center'>
					<span className='flex items-center gap-2 border border-primary/60 text-primary px-2 py-0.5 rounded-full text-[11px] font-semibold uppercase tracking-wide'>
						<Tag size={18} className='text-primary/60' />
						{type}
					</span>
				</div>
				<span
					className={`text-xs font-medium px-3 py-2 rounded-3xl ${
						status === "Inactivo"
							? "bg-gray-100 text-gray-500"
							: "bg-secondary text-primary"
					}`}
				>
					{status}
				</span>
			</div>

			{/* --- Código y Fecha --- */}
			<div className='flex items-baseline gap-2 mb-1 flex-wrap'>
				<span className='text-xl font-bold text-gray-700 uppercase'>{code}</span>
			</div>
			<div>
					<span className='text-xs text-gray-400 font-light whitespace-nowrap'>
						{validUntil ? `Válido hasta ${validUntil}` : "Sin fecha de expiración"}
					</span>
			</div>

			{/* --- Descuento --- */}
			<div className='text-base font-medium text-primary mb-6'>{`${(discount ?? 0) * 100}% de descuento`}</div>

			{/* --- Botón --- */}
			<div className='w-full'>
				<button
					onClick={handleCopy}
					className={`w-full text-center px-4 py-2 rounded-3xl text-sm font-semibold transition-all cursor-pointer ${
						copied
							? "bg-secondary text-primary hover:text-primary-hover"
							: "bg-secondary text-primary hover:bg-secondary-hover hover:text-primary-hover/75 active:scale-95"
					}`}
				>
					<Copy size={16} className='inline mr-2' />
					{copied ? "¡Copiado!" : "Copiar Código"}
				</button>
			</div>
		</div>
	);
};
